import { render, staticRenderFns } from "./PhotoGallery.vue?vue&type=template&id=2720781a&scoped=true&"
import script from "./PhotoGallery.vue?vue&type=script&lang=js&"
export * from "./PhotoGallery.vue?vue&type=script&lang=js&"
import style0 from "./PhotoGallery.vue?vue&type=style&index=0&id=2720781a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2720781a",
  null
  
)

export default component.exports